import ModalSmartDevices from "./ModalSmartDevices";

export default ModalSmartDevices;